/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TrainingHistoryEntry } from './TrainingHistoryEntry';
import {
    TrainingHistoryEntryFromJSON,
    TrainingHistoryEntryFromJSONTyped,
    TrainingHistoryEntryToJSON,
    TrainingHistoryEntryToJSONTyped,
} from './TrainingHistoryEntry';

/**
 * 
 * @export
 * @interface TrainingHistory
 */
export interface TrainingHistory {
    /**
     * 
     * @type {Array<TrainingHistoryEntry>}
     * @memberof TrainingHistory
     */
    historyEntries: Array<TrainingHistoryEntry>;
}

/**
 * Check if a given object implements the TrainingHistory interface.
 */
export function instanceOfTrainingHistory(value: object): value is TrainingHistory {
    if (!('historyEntries' in value) || value['historyEntries'] === undefined) return false;
    return true;
}

export function TrainingHistoryFromJSON(json: any): TrainingHistory {
    return TrainingHistoryFromJSONTyped(json, false);
}

export function TrainingHistoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainingHistory {
    if (json == null) {
        return json;
    }
    return {
        
        'historyEntries': ((json['historyEntries'] as Array<any>).map(TrainingHistoryEntryFromJSON)),
    };
}

export function TrainingHistoryToJSON(json: any): TrainingHistory {
    return TrainingHistoryToJSONTyped(json, false);
}

export function TrainingHistoryToJSONTyped(value?: TrainingHistory | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'historyEntries': ((value['historyEntries'] as Array<any>).map(TrainingHistoryEntryToJSON)),
    };
}

